import React from 'react';
import type { SavedProject } from '@doer/frontend-components/creativity-editor';

type ProjectsListProps = {
  currentProjectId: string | null;
  projects: SavedProject[];
  onSelectProject: (projectId: string) => void;
};

export const ProjectsList: React.FC<ProjectsListProps> = ({ currentProjectId, projects, onSelectProject }) => {
  return (
    <div
      style={{
        overflowY: 'auto',
        padding: '12px'
      }}
    >
      {projects.length === 0 ? (
        <div
          style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#000000a8',
            fontSize: '13px'
          }}
        >
          No hay proyectos guardados.
          <br />
          Crea uno nuevo para empezar.
        </div>
      ) : (
        projects.map(project => (
          <div
            key={project.id}
            onClick={project.id === currentProjectId ? undefined : () => onSelectProject(project.id)}
            style={{
              background: project.id === currentProjectId ? 'rgba(99,102,241,0.12)' : 'rgba(255,255,255,0.03)',
              border:
                project.id === currentProjectId ? '1px solid rgba(99,102,241,0.5)' : '1px solid rgba(255,255,255,0.06)',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '8px',
              cursor: project.id === currentProjectId ? 'default' : 'pointer',
              transition: 'all 0.15s'
            }}
            onMouseEnter={e => {
              if (project.id !== currentProjectId) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
              }
            }}
            onMouseLeave={e => {
              if (project.id !== currentProjectId) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
              }
            }}
          >
            {/* Info */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#000000a8',
                    marginBottom: '4px'
                  }}
                >
                  {project.id}
                </div>
                <div
                  style={{
                    fontSize: '11px',
                    color: 'rgba(56, 56, 56, 0.87)'
                  }}
                >
                  {project.width}×{project.height}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
